// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__0mZGd","icon":"Empty_icon__GStmy","title":"Empty_title__4tUud","message":"Empty_message__2g7W-","button":"Empty_button__CcYki"};